import React from 'react';
import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom'

import App from './App';
import Perros from './components/Perros';
import Home from './components/Home';
import Blog from './components/Blog';
import Contacto from './components/Contacto';

const Routes = () => (
 <Router>
     <div>
        <App />
        <Route exact path="/" component={Home} />
        <Route path="/perros" component={Perros} />
        <Route path="/blog" component={Blog} />
        <Route path="/contacto" component={Contacto} />
    </div>
 </Router>
);
export default Routes;


// WEBPACK FOOTER //
// ./src/routes.js